import { render, staticRenderFns } from "./HorizontalNavMenu.vue?vue&type=template&id=0e4d0527"
import script from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalNavMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalNavMenu.vue?vue&type=style&index=0&id=0e4d0527&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e4d0527')) {
      api.createRecord('0e4d0527', component.options)
    } else {
      api.reload('0e4d0527', component.options)
    }
    module.hot.accept("./HorizontalNavMenu.vue?vue&type=template&id=0e4d0527", function () {
      api.rerender('0e4d0527', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
export default component.exports